import React, { useState, useEffect } from "react";
import {
  Typography,
  Paper,
  Chip,
  Stack,
  Tabs,
  Tab,
  Box,
  Button,
  useMediaQuery,
  useTheme,
  Drawer,
  List,
  ListItem,
  ListItemText,
  ListItemButton,
  IconButton,
  Divider,
  CircularProgress,
  TextField,
  Autocomplete,
  alpha,
  Card,
  CardContent,
  Avatar,
  Tooltip,
} from "@mui/material";
import {
  Save,
  Wifi,
  WifiOff,
  ArrowForward,
  Menu as MenuIcon,
  CloudUpload,
  Delete,
  Add,
  Work,
  Construction,
  Assignment,
  Person,
  ArrowBack,
  Terrain,
} from "@mui/icons-material";
import { useLiveQuery } from "dexie-react-hooks";
import { db } from "../db";
import { INITIAL_FORM_DATA } from "../constants";
import api from "../api";

// --- ALT BİLEŞENLER ---
import IdentityTab from "./IdentityTab";
import FieldCharsTab from "./FieldCharsTab";
import HorizonTab from "./HorizonTab";
import AkkFormulaCard from "../components/cards/AkkFormulaCard";
import StorieIndexCard from "../components/cards/StorieIndexCard";
import LegendCard from "../components/cards/LegendCard";

// Hesaplama fonksiyonları
import { calculateAkkClass } from "../utils/akkUtils";
import { calculateStorieIndex } from "../utils/storieUtils";

// --- YARDIMCI COMPONENTLER ---

const CustomTabPanel = (props) => {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      {...other}
      style={{ width: "100%" }}
    >
      {value === index && <Box sx={{ pt: 3, pb: 10 }}>{children}</Box>}
    </div>
  );
};

const calculateSampleString = (horizons) => {
  if (!horizons || horizons.length === 0) return "";
  const takenSamples = horizons.filter((h) => !h.ornek_alinamadi);
  if (takenSamples.length === 0) return "Hiç örnek alınmadı";
  return takenSamples
    .map((h) => {
      const min = h.derinlik_min;
      const max = h.derinlik_max || "?";
      return `(${min}-${max})`;
    })
    .join("");
};

export default function FieldAgentPage({ user }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const navbarHeight = 64; // Standart MUI Navbar yüksekliği

  const [formData, setFormData] = useState(INITIAL_FORM_DATA);
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [tabValue, setTabValue] = useState(0);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [isSyncing, setIsSyncing] = useState(false);
  const [jobs, setJobs] = useState([]);
  const [selectedJob, setSelectedJob] = useState(null);
  const [coordinators, setCoordinators] = useState([]); // --- LOCAL DB SORGUSU ---

  const savedProfiles = useLiveQuery(() => db.pending_tasks.toArray());

  useEffect(() => {
    window.addEventListener("online", () => setIsOnline(true));
    window.addEventListener("offline", () => setIsOnline(false));
    return () => {
      window.removeEventListener("online", () => setIsOnline(true));
      window.removeEventListener("offline", () => setIsOnline(false));
    };
  }, []);

  useEffect(() => {
    const fetchInitialData = async () => {
      if (!navigator.onLine) return;
      try {
        // 1. Personele atanmış AKTİF PROFİL çalışmalarını çek
        const res = await api.get("/admin/my-active-jobs", {
          params: { type: "profile" },
        });

        if (res.data.success) {
          setJobs(res.data.jobs); // Eğer yerel hafızadan bir form yüklendiyse, selectedJob'ı eşleştir

          if (formData.job_id) {
            const matchedJob = res.data.jobs.find(
              (j) => j.id === formData.job_id,
            );
            if (matchedJob) setSelectedJob(matchedJob);
          }
        } // 2. Koordinatörleri çek

        const coordRes = await api.get("/admin/coordinators");
        if (coordRes.data.success) {
          setCoordinators(coordRes.data.data);
        }
      } catch (error) {
        console.error("Başlangıç verileri çekilirken hata oluştu:", error);
      }
    };

    fetchInitialData();
  }, [formData.job_id]);

  /*
  const saveToLocal = async () => {
    // --- 1. VALIDASYON AYARLARI ---

    // Boş kalabilecek alanlar (İstisnalar)
    const optionalFields = [
      "mahalle",
      "koordinat_x",
      "koordinat_y",
      "iklim",
      "ort_sicaklik",
      "ort_yagis",
      "kaya_tipi",
      "mikrorolyef",
      "arazi_aciklama",
      "kok_gel_derinlik",
      "kok_gel_eng_faktor",
      "taban_suyu_min",
      "taban_suyu_max",
      "taban_suyu_belirti",
      "dusunceler",
      "resim_horizon",
      "resimler_cevre",
      "alinan_ornekler",
      "job_id",
      "tuzluluk",
      "alkalilik",
    ];

    const fieldLabels = {
      calismanin_adi: "Çalışma Adı",
      profil_no: "Profil No",
      cuval_no: "Çuval No",
      tanimlayan: "Tanımlayan",
      tarih: "Tarih",
      il: "İl",
      ilce: "İlçe",
      toprak_serisi: "Toprak Serisi",
      seri_kodu: "Seri Kodu",
      profilgrup: "Profil Grubu",
      yukseklik: "Yükseklik",
      fizyografya: "Fizyografya",
      ana_materyal: "Ana Materyal",
      btg: "Büyük Toprak Grubu",
      arazi_kullanim_sinif: "Arazi Kullanım Sınıfı",
      arazi_kullanim_detay: "Kullanım Detayı",
      urun: "Mevcut Ürün",
      tesirli_derinlik: "Tesirli Derinlik",
      egim_yuzde: "Eğim %",
      egim_yonu: "Eğim Yönü",
      tabii_drenaj: "Tabii Drenaj",
      sel_basmasi: "Sel Basması",
      taskin_olasiligi: "Taşkın Olasılığı",
      erozyon_sekli: "Erozyon Şekli",
      su_erozyon_derecesi: "Su Erozyon Derecesi",
      ruzgar_asinma: "Rüzgar Aşınma",
      ruzgar_yigilma: "Rüzgar Yığılma",
      insan_etkisi: "İnsan Etkisi",
      taslilik: "Taşlılık",
      cakillilik: "Çakıllılık",
      kayalilik: "Kayalılık",
      yuzey_catlak: "Yüzey Çatlağı",
      yuzey_topografyasi: "Yüzey Topoğrafyası (Rölyef)",
    }; // --- 2. ANA FORM KONTROLÜ ---

    for (const key in INITIAL_FORM_DATA) {
      if (
        optionalFields.includes(key) ||
        key === "horizons" ||
        key === "horizon_sayisi"
      ) {
        continue;
      }

      const val = formData[key];
      if (
        val === "" ||
        val === null ||
        val === undefined ||
        (Array.isArray(val) && val.length === 0)
      ) {
        alert(
          `Eksik Veri: "${fieldLabels[key] || key}" alanı boş bırakılamaz!`,
        );

        const tabIdx = [
          "calismanin_adi",
          "profil_no",
          "cuval_no",
          "tanimlayan",
          "tarih",
          "il",
          "ilce",
          "toprak_serisi",
          "seri_kodu",
          "profilgrup",
          "yukseklik",
        ].includes(key)
          ? 0
          : 1;

        setTabValue(tabIdx);
        return;
      }
    } // --- 3. HORIZON KONTROLÜ (RENK MANTIĞI EKLENDİ) ---

    if (!formData.horizons || formData.horizons.length === 0) {
      alert("En az bir horizon girilmelidir!");
      setTabValue(2);
      return;
    }

    for (let i = 0; i < formData.horizons.length; i++) {
      const h = formData.horizons[i];

      const hasKuruSinif = !!h.renk_sinif_kuru;
      const hasKuruKod = !!h.renk_kod_kuru;
      const hasYasSinif = !!h.renk_sinif_yas;
      const hasYasKod = !!h.renk_kod_yas;

      const kuruTam = hasKuruSinif && hasKuruKod;
      const kuruYarim =
        (hasKuruSinif && !hasKuruKod) || (!hasKuruSinif && hasKuruKod);
      const yasTam = hasYasSinif && hasYasKod;
      const yasYarim =
        (hasYasSinif && !hasYasKod) || (!hasYasSinif && hasYasKod);

      if (kuruYarim) {
        alert(
          `${i + 1}. Horizon: Kuru renk eksik! Hem Sınıf (Hue) hem Kod (Val/Chr) seçilmelidir.`,
        );
        setTabValue(2);
        return;
      }
      if (yasYarim) {
        alert(
          `${i + 1}. Horizon: Yaş renk eksik! Hem Sınıf (Hue) hem Kod (Val/Chr) seçilmelidir.`,
        );
        setTabValue(2);
        return;
      }
      if (!kuruTam && !yasTam) {
        alert(
          `${i + 1}. Horizon: En az bir renk türü (Kuru veya Yaş) tam olarak girilmelidir!`,
        );
        setTabValue(2);
        return;
      } // Hangi alanların zorunlu tutulMAYACAĞINI belirliyoruz

      let fieldsToSkip = [
        "ozel_gorunum",
        "ornek_alinamadi",
        "derinlik_arti",
        "no",
        "renk_sinif_kuru",
        "renk_kod_kuru",
        "renk_sinif_yas",
        "renk_kod_yas",
      ]; // EĞER KURU RENK YOKSA, KURU KIVAMI ZORUNLU TUTMA

      if (!kuruTam) fieldsToSkip.push("kivam_kuru"); // EĞER YAŞ RENK YOKSA, NEMLİ VE YAŞ KIVAMLARI ZORUNLU TUTMA

      if (!yasTam)
        fieldsToSkip.push(
          "kivam_nemli",
          "kivam_yas_yapiskanlik",
          "kivam_yas_plastiklik",
        ); // Diğer Özelliklerin Kontrolü

      for (const hKey in h) {
        if (fieldsToSkip.includes(hKey)) continue;

        const hVal = h[hKey];
        if (
          hVal === "" ||
          hVal === null ||
          hVal === undefined ||
          (Array.isArray(hVal) && hVal.length === 0)
        ) {
          alert(
            `${i + 1}. Horizon içerisinde eksik alan var! (Renk seçimine bağlı fiziksel özellikleri doldurunuz)`,
          );
          setTabValue(2);
          return;
        }
      }
    } // --- 4. KAYIT İŞLEMİ (TÜMÜ DOLUYSA) ---

    try {
      const akkResult = calculateAkkClass(formData);
      const storieResult = calculateStorieIndex(formData);
      const sampleString = calculateSampleString(formData.horizons);

      const fullLocation = [formData.il, formData.ilce, formData.mahalle]
        .filter((part) => part && part.trim() !== "")
        .join(" / ");

      const profileToSave = {
        ...formData,
        yeri: fullLocation,
        akk_class_result: akkResult.finalClass + akkResult.subClassString,
        storie_index_result: storieResult.totalIndex,
        storie_class_result: storieResult.storieClass,
        alinan_ornekler: sampleString,
        timestamp: new Date().toISOString(),
        status: "pending",
        user_id: user?.id || 0,
      };

      if (profileToSave.id) {
        await db.pending_tasks.put(profileToSave);
        alert(`✅ Profil No: ${profileToSave.profil_no} güncellendi.`);
      } else {
        delete profileToSave.id;
        await db.pending_tasks.add(profileToSave);
        alert(`✅ Profil No: ${profileToSave.profil_no} kaydedildi.`);
      }
    } catch (error) {
      console.error("Kayıt Hatası:", error);
      alert("Hata: " + error.message);
    }
  };
  */

  const handleNewForm = () => {
    if (window.confirm("Form temizlenecek. Onaylıyor musunuz?")) {
      setFormData(INITIAL_FORM_DATA);
      setSelectedJob(null);
      setTabValue(0);
      setDrawerOpen(false);
    }
  };

  const loadProfile = (profile) => {
    setFormData(profile);
    setTabValue(0);
    setDrawerOpen(false);
  };

  const deleteProfile = async (id, e) => {
    e.stopPropagation();
    if (window.confirm("Silmek istediğinize emin misiniz?")) {
      await db.pending_tasks.delete(id);
    }
  };

  const handleSync = async () => {
    if (!isOnline) return alert("İnternet bağlantısı yok!");
    if (!savedProfiles || savedProfiles.length === 0)
      return alert("Gönderilecek veri yok.");

    setIsSyncing(true);
    try {
      const response = await api.post("/sync/sync-data", {
        userId: user?.id,
        records: savedProfiles,
      });

      if (response.data.success) {
        const results = response.data.results || [];

        const synced = results.filter((r) => r.status === "synced");
        const duplicates = results.filter((r) => r.status === "duplicate");
        const errors = results.filter((r) => r.status === "error");

        // YENİ EKLENEN KISIM: Başarılı olanları yerel DB'den SİL!
        const idsToDelete = synced.map((r) => r.tempId);
        if (idsToDelete.length > 0) {
          await db.pending_tasks.bulkDelete(idsToDelete);
        }

        let message = `🎉 ${synced.length} profil başarıyla sunucuya gönderildi ve cihazdan silindi.`;

        if (duplicates.length > 0) {
          const nos = duplicates.map((r) => r.profil_no).join(", ");
          // Çift kayıtları da cihazdan silebiliriz çünkü zaten sunucuda var.
          const duplicateIds = duplicates.map((r) => r.tempId);
          if (duplicateIds.length > 0) {
            await db.pending_tasks.bulkDelete(duplicateIds);
          }
          message += `\n\n⚠️ ${duplicates.length} profil reddedildi (zaten kayıtlı) ve cihazdan temizlendi:\n${nos}`;
        }

        if (errors.length > 0) {
          const nos = errors.map((r) => r.profil_no).join(", ");
          message += `\n\n❌ ${errors.length} profilde hata oluştu (cihazda tutuluyor):\n${nos}`;
        }

        alert(message);
      }
    } catch (error) {
      console.error("Senkronizasyon Hatası:", error);
      alert("Hata: " + (error.response?.data?.message || error.message));
    } finally {
      setIsSyncing(false);
    }
  };

  const saveToLocal = async () => {
    // --- SADECE MÜŞTERİNİN İSTEDİĞİ KISA KONTROLLER ---
    if (!formData.profil_no || String(formData.profil_no).trim() === "") {
      alert("Eksik Veri: Profil No alanı boş bırakılamaz!");
      setTabValue(0); // Profil No 1. sekmede olduğu için oraya yönlendir
      return;
    }
    if (
      !formData.calismanin_adi ||
      String(formData.calismanin_adi).trim() === ""
    ) {
      alert("Eksik Veri: Çalışma adı alanı boş bırakılamaz!");
      setTabValue(0);
      return;
    }
    if (!formData.cuval_no || String(formData.cuval_no).trim() === "") {
      alert("Eksik Veri: Çuval No alanı boş bırakılamaz!");
      setTabValue(0);
      return;
    }
    if (!formData.tanimlayan || String(formData.tanimlayan).trim() === "") {
      alert("Eksik Veri: Tanımlayan alanı boş bırakılamaz!");
      setTabValue(0);
      return;
    }

    // --- KAYIT İŞLEMİ ---
    try {
      const akkResult = calculateAkkClass(formData);
      const storieResult = calculateStorieIndex(formData);
      const sampleString = calculateSampleString(formData.horizons);

      const fullLocation = [formData.il, formData.ilce, formData.mahalle]
        .filter((part) => part && part.trim() !== "")
        .join(" / ");

      const profileToSave = {
        ...formData,
        yeri: fullLocation,
        akk_class_result: akkResult.finalClass + akkResult.subClassString,
        storie_index_result: storieResult.totalIndex,
        storie_class_result: storieResult.storieClass,
        alinan_ornekler: sampleString,
        timestamp: new Date().toISOString(),
        status: "pending",
        user_id: user?.id || 0,
      };

      if (profileToSave.id) {
        await db.pending_tasks.put(profileToSave);
        alert(`✅ Profil No: ${profileToSave.profil_no} güncellendi.`);
      } else {
        delete profileToSave.id;
        await db.pending_tasks.add(profileToSave);
        alert(`✅ Profil No: ${profileToSave.profil_no} kaydedildi.`);
      }
    } catch (error) {
      console.error("Kayıt Hatası:", error);
      alert("Hata: " + error.message);
    }
  };

  const drawerContent = (
    <Box
      sx={{
        width: 300,
        display: "flex",
        flexDirection: "column",
        height: "100%",
        bgcolor: "#f8f9fa",
      }}
    >
      <Box sx={{ p: 3, bgcolor: "#fff", borderBottom: "1px solid #eee" }}>
        <Typography variant="h6" fontWeight="800" color="primary.main">
          Profil Listesi
        </Typography>

        <Typography variant="caption" color="text.secondary">
          Cihaz Hafızası (Local)
        </Typography>
      </Box>

      <Stack direction="row" spacing={1} sx={{ p: 2 }}>
        <Button
          fullWidth
          variant="contained"
          color="success"
          startIcon={
            isSyncing ? (
              <CircularProgress size={20} color="inherit" />
            ) : (
              <CloudUpload />
            )
          }
          onClick={handleSync}
          disabled={isSyncing || !isOnline}
          sx={{
            borderRadius: "8px",
            textTransform: "none",
            fontWeight: "bold",
          }}
        >
          Senkronize Et
        </Button>

        <Button
          variant="outlined"
          onClick={handleNewForm}
          sx={{ minWidth: "50px", borderRadius: "8px" }}
        >
          <Add />
        </Button>
      </Stack>

      <List sx={{ flexGrow: 1, overflowY: "auto", px: 1 }}>
        {savedProfiles?.map((profile) => (
          <ListItem
            key={profile.id}
            disablePadding
            secondaryAction={
              <IconButton
                edge="end"
                onClick={(e) => deleteProfile(profile.id, e)}
                size="small"
              >
                <Delete fontSize="small" color="error" />
              </IconButton>
            }
            sx={{
              mb: 1,
              bgcolor: "#fff",
              borderRadius: "8px",
              boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
            }}
          >
            <ListItemButton
              onClick={() => loadProfile(profile)}
              sx={{ borderRadius: "8px" }}
            >
              <ListItemText
                primary={
                  <Typography
                    fontWeight="bold"
                    color="primary"
                    fontSize="0.95rem"
                  >
                    {profile.profil_no || "No Yok"}
                  </Typography>
                }
                secondary={
                  <Typography variant="caption">
                    {new Date(profile.timestamp).toLocaleDateString()}
                  </Typography>
                }
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        minHeight: "100vh",
        bgcolor: "#f4f6f8",
      }}
    >
      {/* SIDEBAR (Responsive) */}
      <Box component="nav">
        {/* MOBİL DRAWER */}
        <Drawer
          variant="temporary"
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
          ModalProps={{ keepMounted: true }}
          sx={{
            display: { xs: "block", md: "none" },
            "& .MuiDrawer-paper": {
              width: 300,
              top: navbarHeight,
              height: `calc(100% - ${navbarHeight}px)`,
            },
          }}
        >
          {drawerContent}
        </Drawer>
        {/* MASAÜSTÜ DRAWER (PERSISTENT) */}
        <Drawer
          variant="persistent"
          open={drawerOpen}
          sx={{
            display: { xs: "none", md: "block" },
            "& .MuiDrawer-paper": {
              width: 300,
              top: navbarHeight,
              height: `calc(100vh - ${navbarHeight}px)`,
              borderRight: "1px solid #e0e0e0",
              boxShadow: "4px 0 24px rgba(0,0,0,0.02)",
              zIndex: theme.zIndex.appBar - 1,
            },
          }}
        >
          {drawerContent}
        </Drawer>
      </Box>
      {/* ANA İÇERİK */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: { xs: 2, md: 4 },
          width: "100%",
          ml: { md: drawerOpen ? "300px" : 0 },
          transition: "margin 0.3s",
        }}
      >
        {/* HEADER BAR */}
        <Paper
          elevation={0}
          sx={{
            p: 2,
            mb: 3,
            borderRadius: "16px",
            border: "1px solid #eaecf0",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: 2,
          }}
        >
          <Stack direction="row" alignItems="center" spacing={2}>
            <IconButton
              onClick={() => setDrawerOpen(!drawerOpen)}
              sx={{ bgcolor: "#f0f2f5" }}
            >
              <MenuIcon color="action" />
            </IconButton>

            <Box>
              <Typography
                variant="h6"
                fontWeight="800"
                color="text.primary"
                lineHeight={1.2}
              >
                Arazi Veri Girişi
              </Typography>

              <Stack direction="row" alignItems="center" spacing={1}>
                <Person sx={{ fontSize: 16, color: "text.secondary" }} />

                <Typography
                  variant="caption"
                  color="text.secondary"
                  fontWeight="500"
                >
                  {user?.full_name}
                </Typography>
              </Stack>
            </Box>

            <Tooltip title="Yeni Boş Form">
              <IconButton
                onClick={handleNewForm}
                sx={{
                  bgcolor: alpha(theme.palette.primary.main, 0.1),
                  color: "primary.main",
                  ml: 1,
                  "&:hover": {
                    bgcolor: alpha(theme.palette.primary.main, 0.2),
                  },
                }}
              >
                <Add />
              </IconButton>
            </Tooltip>
          </Stack>

          <Stack direction="row" spacing={2} alignItems="center">
            <Chip
              icon={isOnline ? <Wifi /> : <WifiOff />}
              label={isOnline ? "Online" : "Offline"}
              color={isOnline ? "success" : "default"}
              sx={{ fontWeight: "bold", borderRadius: "8px" }}
            />
          </Stack>
        </Paper>
        {/* İŞ SEÇİM KARTI */}
        <Card
          elevation={0}
          sx={{
            mb: 3,
            borderRadius: "16px",
            border: "1px solid #eaecf0",
            background: "linear-gradient(to right, #ffffff, #f8f9fa)",
          }}
        >
          <CardContent
            sx={{ p: 3, display: "flex", alignItems: "center", gap: 3 }}
          >
            <Avatar
              variant="rounded"
              sx={{
                bgcolor: alpha(theme.palette.primary.main, 0.1),
                color: "primary.main",
                width: 48,
                height: 48,
              }}
            >
              <Work />
            </Avatar>

            <Box sx={{ flexGrow: 1 }}>
              <Typography
                variant="subtitle2"
                color="primary"
                fontWeight="bold"
                sx={{ mb: 0.5 }}
              >
                AKTİF ÇALIŞMA (GÖREV)
              </Typography>

              <Autocomplete
                options={jobs}
                value={selectedJob}
                getOptionLabel={(option) =>
                  `${option.job_name} (${option.province})`
                }
                isOptionEqualToValue={(option, value) => option.id === value.id}
                onChange={(event, newValue) => {
                  setSelectedJob(newValue);
                  if (newValue) {
                    setFormData((prev) => ({
                      ...prev,
                      job_id: newValue.id,
                      calismanin_adi: newValue.job_name,
                      il: newValue.province,
                      yeri: "",
                      bolge: newValue.region,
                    }));
                  } else {
                    setFormData((prev) => ({
                      ...prev,
                      job_id: null,
                      calismanin_adi: "",
                      il: "",
                      yeri: "",
                      bolge: "",
                    }));
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Listeden bir çalışma seçiniz..."
                    variant="standard"
                    fullWidth
                    InputProps={{
                      ...params.InputProps,
                      disableUnderline: true,
                      sx: { fontSize: "1.1rem", fontWeight: 500 },
                    }}
                  />
                )}
                noOptionsText="Aktif çalışma bulunamadı."
              />
            </Box>
          </CardContent>
        </Card>
        {/* ANA FORM ALANI (TABS) */}
        <Paper
          elevation={0}
          sx={{
            borderRadius: "16px",
            border: "1px solid #eaecf0",
            overflow: "hidden",
          }}
        >
          <Box
            sx={{ borderBottom: 1, borderColor: "divider", bgcolor: "#fff" }}
          >
            <Tabs
              value={tabValue}
              onChange={(e, v) => setTabValue(v)}
              variant={isMobile ? "scrollable" : "fullWidth"}
              scrollButtons="auto"
              sx={{
                "& .MuiTab-root": {
                  textTransform: "none",
                  fontWeight: 600,
                  fontSize: "0.95rem",
                  py: 2,
                },
                "& .Mui-selected": { color: "primary.main" },
              }}
            >
              <Tab
                label="1. Kimlik Bilgileri"
                icon={<Assignment />}
                iconPosition="start"
              />

              <Tab
                label="2. Saha Karakteristiği"
                icon={<Terrain />}
                iconPosition="start"
              />

              <Tab
                label="3. Horizon & Analiz"
                icon={<MenuIcon />}
                iconPosition="start"
              />
            </Tabs>
          </Box>

          <Box sx={{ p: { xs: 2, md: 4 }, bgcolor: "#fff" }}>
            {/* TAB 1: KİMLİK */}
            <CustomTabPanel value={tabValue} index={0}>
              <IdentityTab
                formData={formData}
                setFormData={setFormData}
                coordinators={coordinators}
              />

              <Stack direction="row" justifyContent="flex-end" mt={4}>
                <Button
                  variant="contained"
                  endIcon={<ArrowForward />}
                  onClick={() => setTabValue(1)}
                  size="large"
                  sx={{ borderRadius: "10px", px: 4 }}
                >
                  İleri: Saha Özellikleri
                </Button>
              </Stack>
            </CustomTabPanel>
            {/* TAB 2: SAHA */}
            <CustomTabPanel value={tabValue} index={1}>
              <FieldCharsTab formData={formData} setFormData={setFormData} />

              <Stack direction="row" justifyContent="space-between" mt={4}>
                <Button
                  startIcon={<ArrowBack />}
                  onClick={() => setTabValue(0)}
                  color="inherit"
                >
                  Geri
                </Button>

                <Button
                  variant="contained"
                  endIcon={<ArrowForward />}
                  onClick={() => setTabValue(2)}
                  size="large"
                  sx={{ borderRadius: "10px", px: 4 }}
                >
                  İleri: Horizonlar
                </Button>
              </Stack>
            </CustomTabPanel>
            {/* TAB 3: HORIZON */}
            <CustomTabPanel value={tabValue} index={2}>
              <HorizonTab formData={formData} setFormData={setFormData} />

              <Box sx={{ mt: 5, mb: 3 }}>
                <Divider sx={{ mb: 4 }}>
                  <Chip label="OTOMATİK HESAPLAMALAR" />
                </Divider>

                <Stack spacing={3}>
                  <Box sx={{ width: "100%" }}>
                    <LegendCard formData={formData} />
                  </Box>

                  <Stack direction={{ xs: "column", md: "row" }} spacing={3}>
                    <Box sx={{ flex: 1 }}>
                      <AkkFormulaCard formData={formData} />
                    </Box>
                    <Box sx={{ flex: 1 }}>
                      <StorieIndexCard formData={formData} />
                    </Box>
                  </Stack>
                </Stack>
              </Box>
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                mt={4}
                pt={3}
                borderTop="1px solid #eee"
              >
                <Button
                  startIcon={<ArrowBack />}
                  onClick={() => setTabValue(1)}
                  color="inherit"
                >
                  Geri
                </Button>
                <Stack direction="row" spacing={2} alignItems="center">
                  {formData.status === "pending" && (
                    <Chip
                      label="Düzenleme Modu"
                      color="warning"
                      variant="outlined"
                    />
                  )}
                  <Button
                    variant="contained"
                    color="success"
                    size="large"
                    startIcon={<Save />}
                    onClick={saveToLocal}
                    sx={{
                      borderRadius: "10px",
                      px: 5,
                      py: 1.5,
                      fontSize: "1rem",
                      fontWeight: "bold",
                      boxShadow: "0 4px 14px 0 rgba(46, 125, 50, 0.39)",
                    }}
                  >
                    {formData.profil_no
                      ? `${formData.profil_no} KAYDET`
                      : "PROFİLİ KAYDET"}
                  </Button>
                </Stack>
              </Stack>
            </CustomTabPanel>
          </Box>
        </Paper>
      </Box>
    </Box>
  );
}
